import { HttpPostRequest } from "clients/authenticationClient"

interface ResetPasswordPayload {
	password: string
	reset_token: string | null
}

export const resetPw = (
	password: string,
	token: string | null
): Promise<void> => {
	const payload: ResetPasswordPayload = {
		password: password,
		reset_token: token,
	}

	return HttpPostRequest<void, ResetPasswordPayload>(
		"/reset-password",
		payload
	).catch((error: any) => {
		if (error.response && error.response.status === 400) {
			const errorResponse: string = mapErrorReasonToErrorType(
				error.response.data
			)
			throw errorResponse
		} else {
			throw error
		}
	})
}

const mapErrorReasonToErrorType = (reason: string) => {
	switch (reason) {
		case "error in password policies":
			return "password"
		case "invalid or expired reset token":
			return "token"
		default:
			return reason
	}
}
